import { slLanguageInterceptor } from '@screenleads/i18n';
import { provideZoneChangeDetection } from '@angular/core';
// src/app/app.config.ts
import { ApplicationConfig, APP_INITIALIZER, inject } from '@angular/core';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { authenticationInterceptor } from './core/interceptors/authentication.interceptor';
import { AuthStore } from './core/store/auth.store';
import { CompanyThemeService } from './core/services/company-theme.service';


function initAuthFactory() {
  const auth=inject(AuthStore);
  const theme=inject(CompanyThemeService);
  return async()=>{
    await auth.hydrateFromStorageAndRefreshUser();
    await theme.loadCompanyThemeAsync(auth.companyId() ?? 1);
  };
}

import { customDateProviders } from './core/custom-date.providers';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({eventCoalescing:true}),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([slLanguageInterceptor,authenticationInterceptor])),
    ...customDateProviders,
    {
      provide: APP_INITIALIZER,
      useFactory: initAuthFactory,
      multi: true
    }
  ]
};
